<template>
  <v-page page="Receivables" :breadcrumb="breadcrumb">
    <Spinner ref="spinner"></Spinner>
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3>
                  <v-flex align-center>
                    <div
                      v-show="(BAN == null) || (BAN == 'all')"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Accounts Receivable</div>
                    <div
                      v-show="(BAN != null) && (BAN != 'all')"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Receivables for Account # {{ BAN }}</div>
                  </v-flex>
                  <v-flex align-center xs6>
                    <v-layout row>
                      <v-flex xs3 shrink>
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            class="mt-0 pt-0 mr-3 align-center"
                            slot="activator"
                            v-model="filters.DateForFilter"
                            label="Date"
                            prepend-inner-icon="fa-calendar-alt"
                            readonly
                            clearable
                            @input="filterReceivables"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-date-picker
                            v-model="filters.DateForFilter"
                            @input="menu = false"
                            @change="filterReceivables"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlType"
                          v-model="filters.Type"
                          item-text="Text"
                          item-value="Value"
                          label="Type"
                          clearable
                          @change="filterReceivables"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs6 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterReceivables"
                          ></v-text-field>
                          <v-btn @click="filterReceivables" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- Buttons -->
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportToExcel"
                      >EXCEL</a>
                      <v-btn
                        v-show="hasArRole"
                        class="TierButton mb-1 mr-0 ml-1"
                        :to="openCreateBatch()"
                      >+ New AR Batch</v-btn>
                      <!-- <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          :href="printIssueList"
                          target="_blank"
                          >PRINT ISSUE LIST</a
                        >
                        <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          :href="exportToExcel"
                          target="_blank"
                          >EXPORT TO EXCEL</a
                      >-->
                      <!-- <v-btn class="TierButton mb-1 mr-0 ml-1" @click="openCreateAccountForm">
                        + New Account
                      </v-btn>-->
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- <v-layout v-show="showResetBtn && !loading" justify-start row align-center mt-0 mb-0>
                  <v-flex align-center>
                    <div class="text-xs-left align-center" style="font-size: 20px; font-weight: 600;">Parent Account # {{ parentBAN }}</div>
                  </v-flex>
                </v-layout>-->

                <!-- RECEIVABLES TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="receivables"
                  :item-key="receivables.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="pagination.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight :queries="searchHighlight">{{ props.item["AccountBAN"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">
                          {{
                          (props.item["AccountName1"] + ' ' +
                          (props.item["AccountName2"] == null ? "" :props.item["AccountName2"])
                          ).trim() }}
                        </text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatDate(props.item["Date"]) }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["TypeDescription"] | capitalize }}</text-highlight>
                      </td>
                      <td class="text-xs-left pr-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["Description"] }}</text-highlight>
                      </td>
                      <td
                        :class="{'justify-end align-center text-xs-right pr-0 pt-0 pb-0': props.item.Amount >= 0, 'justify-end align-center text-xs-right pr-0 pt-0 pb-0 red--text': props.item.Amount < 0}"
                      >
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatCurrency(props.item["Amount"]) }}</text-highlight>
                      </td>
                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <!-- <a class="mr-3"
                          :href="props.item.url"
                          style="text-decoration: none"
                          target="_blank">
                          VIEW
                        </a>-->
                        <a
                          v-show="props.item.Type == 'IN'"
                          class="mr-0"
                          style="text-decoration: none"
                          @click="exportToPDF(props.item)"
                        >PDF</a>
                      </td>
                    </tr>
                  </template>
                  <template slot="footer">
                    <td class="text-xs-left pl-0" colspan="3">
                      <strong>
                        Total
                        Records:
                      </strong>
                      {{ numberWithCommas(pagination.totalRecords) }}
                    </td>
                    <td class="text-xs-right"></td>
                    <td class="justify-end text-xs-right pr-0" colspan="2">
                      <v-layout row>
                        <v-flex xs7>
                          <strong>Total Amount:</strong>
                        </v-flex>
                        <v-flex
                          xs5
                          :class="{'red--text': totalAmount < 0}"
                        >{{ formatCurrency(totalAmount) }}</v-flex>
                      </v-layout>
                    </td>
                     <td class="text-xs-right"></td>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="pagination.totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetReceivablesList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import Spinner from "../../components/Spinner.vue";
import TextHighlight from "vue-text-highlight";
import "@/assets/css/main.css"
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Receivables",

  components: {
    VPage,
    Spinner,
    "text-highlight": TextHighlight,
     DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,
    hasArRole: false,
    BAN: "",

    showResetBtn: false,

    filtersChanged: false,
    filters: {},

    ddlType: [],

    menu: false,
    totalAmount: null,
    searchHighlight: "",

    rowsPerPageItems: [30, 45, 60, 100],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: true,
      totalRecords: 0,
      sortBy: "Date",
      page: 1
    },

    breadcrumb: [
      {
        text: "Receivables",
        disabled: false,
        href: "#/receivables/all"
      },
      {
        text: "All",
        disabled: true,
        href: "#/receivables/all"
      }
    ],

    headers: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "35%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading"
      },
      {
        text: "Date",
        value: "Date",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Type",
        value: "TypeDescription",
        // sortable: false,
        width: "13%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Description",
        value: "Description",
        // sortable: false,
        width: "20%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Amount",
        value: "Amount",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    receivables: [],
    filteredReceivables: []
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },
  filters: {
    capitalize: function(item) {
      if (item) {
        return item.toUpperCase();
      }
    }
  },

  created() {
    this.initialize();
  },

  mounted() {
    this.getArRole();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },

  methods: {
    getArRole() {
      axios({
        method: "post",
        url: "/api/User/HasRole/",
        data: { roleName: "AR" }
      })
        .then(response => {
          console.log(response.data.hasRole);
          this.hasArRole = response.data.hasRole;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async initialize() {
      this.loading = true;
      // this.filters = {}

      this.BAN = this.$route.params.BAN;

      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
    }

      if (this.BAN !== "all") {
        this.filters = {
          AccountBAN: this.BAN
        };

        this.filtersChanged = true;

        this.breadcrumb[1].text = this.BAN;
        this.showResetBtn = true;
      } else {
        this.breadcrumb[1].text = "all";
        this.filters = {};
        this.filtersChanged = true;
        this.showResetBtn = false;
      }
      this.getArRole();
      this.getDropdownOptions("api/Account/GetReceivablesDDLs", "ddlType");
      await this.paginationUpdated();

      this.loading = false;
    },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Receivables/GetPagedReceivablesList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.receivables = response.data.receivables;
          this.pagination.totalRecords = response.data.pagination.totalRecords;
          this.totalAmount = response.data.totalAmount;
        });
      this.loading = false;
      this.filtersChanged = false;
    },

    // Get list of dropdown options
    async getDropdownOptions(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async resetReceivablesList() {
      this.loading = true;
      this.$router.push("/receivables/all");

      this.filters = {};
      this.filtersChanged = true;
      this.searchHighlight = "";
      this.search = "";
      this.breadcrumb[1].text = "all";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    openAccountSummaryPage(item) {
      return "/account-summary/" + item.AccountBAN;
    },

    formatDate(value) {
      if (value) return moment(value).format("YYYY-MM-DD");
      else return "";
    },

    async filterReceivables() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()
      await this.paginationUpdated();
    },

    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },
    numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
},
    openCreateBatch() {
      return "/active-batches/true";
    },
    exportToExcel() {
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Excel/accountReceivables/" + this.BAN,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "AccountReceivables." + currentDate + ".xlsx"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    exportToPDF(item) {
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Receivables/DownloadPDF/"+item.DocId,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          
          var accountBAN = this.padLeadingZeros(item.AccountBAN, 12)
          var docId = this.padLeadingZeros(item.DocId, 10)

          var filename = accountBAN+docId
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            filename + ".pdf"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();

          var blob = new window.Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        var win = window.open();
        win.document.write(
          '<iframe src="' +
            fileURL +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
        );
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    padLeadingZeros(num, size) {
    var s = "000000000000000" + num;
    return s.substr(s.length-size);
},
updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
